import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Shared';
export type TestimonialProps = {
  initials: string;
  name: string;
  location: string;
  context?: string;
  text: string;
  accent?: 'sage' | 'rose' | 'gold';
};
const accents: Record<NonNullable<TestimonialProps['accent']>, string> = {
  sage: 'bg-brand-sageMid',
  rose: 'bg-brand-rose',
  gold: 'bg-brand-gold'
};
export function TestimonialCard({
  initials,
  name,
  location,
  context,
  text,
  accent = 'sage'
}: TestimonialProps) {
  return <article className="paper-panel flex h-full flex-col rounded-2xl border-l-4 border-l-brand-gold p-6 md:p-8" data-id="element-300" data-mp="31z3cwupkrpai">
      <div className="mb-4 flex items-center" data-id="element-301" data-mp="2x11tg8o8lnyi">
        <div className={`mr-4 flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-sm font-bold text-brand-cream ring-1 ring-brand-gold/40 md:text-lg ${accents[accent]}`} data-id="element-302" data-mp="2s28e0ape3mvp">
          {initials}
        </div>
        <div data-id="element-303" data-mp="qav93lnf9ezn">
          <div className="mb-1 flex text-brand-gold" data-id="element-304" data-mp="q893vso07bkl">
            {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" data-id="element-305" data-mp="h8ax9aoyulpn" />)}
          </div>
          <p className="font-semibold text-brand-taupe md:text-lg" data-id="element-306" data-mp="m2onyzsoo4nz">{name}</p>
          <p className="text-xs text-brand-muted md:text-sm" data-id="element-307" data-mp="79lfdhx2l19e">
            {location}
            {context ? ` — ${context}` : ''}
          </p>
        </div>
      </div>
      <p className="flex-grow font-display text-sm italic leading-relaxed text-brand-textLight md:text-base" data-id="element-308" data-mp="zxh86bjiq90w">
        “{text}”
      </p>
    </article>;
}
const testimonials: TestimonialProps[] = [{
  initials: 'MG',
  name: 'Martina G.',
  location: 'CABA',
  context: 'Emprendedora de Cosmética Natural',
  accent: 'sage',
  text: 'Hace 3 meses vendo cremas sin estrategia. Con este pack aprendí a calcular mis costos reales, a diseñar etiquetas que venden y, lo más importante, a cobrar premium sin culpa. Este mes llegué a $40.000 ARS. Antes ganaba $8.000.'
}, {
  initials: 'LM',
  name: 'Lucía M.',
  location: 'Mendoza',
  context: 'Skincare Consciente',
  accent: 'rose',
  text: 'La parte de alquimia vibracional y programación lunar cambió mi forma de trabajar. Mis clientes notan la diferencia desde el primer uso. Además, el branding magnético hizo que mis redes crecieran 300% en 2 meses.'
}, {
  initials: 'DR',
  name: 'Daniela R.',
  location: 'Rosario',
  context: 'Recién emprendedora',
  accent: 'gold',
  text: 'Recién empezaba y no sabía por dónde arrancar. Este pack me dio toda la estructura desde el primer día: desde qué insumos comprar hasta cómo cerrar la venta por WhatsApp. Ahora trabajo con criterio y mis productos se venden solos.'
}];
export function InitialTestimonials() {
  return <Section className="pb-14 pt-6" data-id="element-309" data-mp="vt6nrql4u2kv">
      <div className="mx-auto max-w-3xl" data-id="element-310" data-mp="vrc4shtf8kjf">
        <TestimonialCard {...testimonials[0]} data-id="element-311" data-mp="qtka5g1e6kbj" />
      </div>
    </Section>;
}
export function MoreTestimonials() {
  return <Section className="pb-16 pt-8" data-id="element-312" data-mp="32hp5t1ufkbnp">
      <div className="mb-10 text-center" data-id="element-313" data-mp="32gnssrtutf3c">
        <h2 className="font-serif text-2xl font-bold text-brand-taupe md:text-4xl" data-id="element-314" data-mp="37fqp9nvrqczp">
          ❤️ LO QUE DICEN LAS EMPRENDEDORAS QUE YA LO TIENEN
        </h2>
      </div>
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 md:grid-cols-3" data-id="element-315" data-mp="3ccz69l56kazd">
        {testimonials.map(testimonial => <TestimonialCard key={testimonial.initials} {...testimonial} data-id="element-316" data-mp="2jqo7mg14wk57" />)}
      </div>
    </Section>;
}